import React from 'react';
import {
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  Input,
  Button
} from '@mui/joy';

/**
 * Modal for displaying and applying generated policy suggestions
 */
const GeneratedPolicyModal = ({
  open,
  onClose,
  policyDefinition,
  onApply
}) => {
  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog sx={{ width: 1024 }}>
        <ModalClose />
        <DialogTitle>
          <Typography level='title-md'>
            Here are some suggested changes you can apply to your policy.
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {policyDefinition && Object.entries(policyDefinition).filter(([key, value]) =>
            key !== 'index' &&
            value != null &&
            value.length !== 0
          ).map(([key, value]) => (
            <React.Fragment key={key}>
              <Typography level="title-sm">{key}:</Typography>
              <Input readOnly value={value} sx={{ mb: 2 }} />
            </React.Fragment>
          ))}
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={onApply}>
            Apply
          </Button>
          <Button variant="plain" color="danger" onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default GeneratedPolicyModal;
